import { useLiveQuery } from 'dexie-react-hooks';
import offlineDb from '@/services/offline/db';

export function usePrefetchStatus(providerId) {
  const state = useLiveQuery(
    () => providerId ? offlineDb.prefetchState.get(providerId) : null,
    [providerId]
  );

  return {
    status: state?.status || 'idle',
    completed: state?.completed || 0,
    total: state?.total || 0,
    lastUpdated: state?.lastUpdated || null,
    isPrefetching: state?.status === 'in_progress',
  };
}
